import { render, staticRenderFns } from "./SamplechecksDetail.vue?vue&type=template&id=6d1192b1&scoped=true&"
import script from "./SamplechecksDetail.vue?vue&type=script&lang=js&"
export * from "./SamplechecksDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d1192b1",
  null
  
)

export default component.exports